import {JSX} from "react";

import Link from "next/link";

import "./styles/breadcrumbs.scss";

export interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface BreadcrumbsProps {
    items: Array<BreadcrumbItem>;
    separator?: string;
}

export const Breadcrumbs = ({items, separator = "/"}: BreadcrumbsProps): JSX.Element | null => {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <nav className="breadcrumbs" aria-label="Breadcrumb">
            <ol className="breadcrumbs__list">
                {items.map((item, idx) => {
                    const isLast = idx === items.length - 1;
                    return (
                        <li key={`${item.label}-${idx}`} className="breadcrumbs__item">
                            {item.href && !isLast ? (
                                <Link href={item.href} className="breadcrumbs__link">
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="breadcrumbs__current" aria-current="page">
                                    {item.label}
                                </span>
                            )}
                            {!isLast && (
                                <span className="breadcrumbs__separator" aria-hidden={isLast}>
                                    {separator}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};
